<div class="restore-timeline-dialog">
    <h1 mat-dialog-title>
        <mat-icon>restore</mat-icon>
        Restore Deleted Timeline Items
    </h1>
    
    <div mat-dialog-content class="restore-timeline-content">
        <ng-container *ngIf="loading; else contentLoaded">
            <div class="list-loading">
                <mat-spinner color="primary" mode="indeterminate" diameter="20" style="float:right;"></mat-spinner>
            </div>
        </ng-container>

        <ng-template #contentLoaded>
            <ng-container *ngIf="deletedItems.length > 0; else noResults">
                <ng-container *ngFor="let group of groupedItems">
                    <div class="list-header">
                        {{ group.date | date: 'longDate' }}
                    </div>
                    <mat-list class="full-width">
                        <ng-container *ngFor="let item of group.items">
                            <ng-container *ngIf="item.type === 'note'">
                                <mat-list-item class="auto-height normal-spacing">
                                    <div class="note-item">
                                        <div class="note-details">
                                            <div matLine class="note-title">
                                                <mat-icon class="record-type-icon" [ngClass]="{
                                                        'mortality-icon': item.isMortality,
                                                        'morbidity-icon': item.isMorbidity,
                                                        'procedure-icon': item.isProcedure,
                                                        'billing-icon': item.isBilling,
                                                        'clinical-icon': !item.isMortality && !item.isMorbidity && !item.isBilling
                                                    }" *ngIf="!item.isProcedure && !item.isBilling"
                                                    [matTooltip]="item.isMortality ? 'Mortality Record' : item.isMorbidity ? 'Morbidity Record' : item.isBilling ? 'Billing Note' : 'Clinical Note'">
                                                    <span *ngIf="item.isMortality">favorite_border</span>
                                                    <span *ngIf="item.isMorbidity">warning</span>
                                                    <span
                                                        *ngIf="!item.isMortality && !item.isMorbidity && !item.isBilling">medical_services</span>
                                                </mat-icon>
                                                <mat-icon svgIcon="scalpel_and_forceps"
                                                    *ngIf="item.isProcedure && isSurgicalSpeciality"
                                                    class="record-type-icon procedure-icon"></mat-icon>
                                                <mat-icon svgIcon="syringe"
                                                    *ngIf="item.isProcedure && !isSurgicalSpeciality"
                                                    class="record-type-icon procedure-icon"></mat-icon>
                                                <mat-icon *ngIf="item.isBilling"
                                                    class="record-type-icon billing-icon"
                                                    [matTooltip]="'Billing Note'">receipt</mat-icon>
                                                <span> {{item.isMorbidity ? 'Morbidity: ' + item.title :
                                                    item.isMortality ? 'Mortality: ' + item.title
                                                    : item.isBilling ? 'Billing: ' + item.title
                                                    : item.title }}</span>
                                            </div>

                                            <div matLine class="note-details preserve-line-breaks"
                                                [innerHtml]="item.notes | formatMessage">
                                            </div>

                                            <div matLine class="note-footer">
                                                <div>Created By: {{ item.createdBy }} at {{item.createdAt | date:
                                                    'HH:mm'}}</div>
                                            </div>

                                            <div class="list-actions icons">
                                                <button mat-icon-button matTooltip="Restore this item"
                                                    [disabled]="restoringIds.has(item.id)"
                                                    (click)="restoreItem(item)">
                                                    <mat-icon *ngIf="!restoringIds.has(item.id)">restore</mat-icon>
                                                    <mat-spinner *ngIf="restoringIds.has(item.id)" diameter="20" class="button-spinner"></mat-spinner>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </mat-list-item>
                            </ng-container>
                            <ng-container *ngIf="item.type === 'admission-record'">
                                <mat-list-item class="auto-height normal-spacing">
                                    <div class="note-item">
                                        <div class="note-details">
                                            <div matLine class="note-title">
                                                <mat-icon class="record-type-icon admission-icon"
                                                    matTooltip="Admission Record">
                                                    local_hospital
                                                </mat-icon>
                                                <span>Admission Record</span>
                                            </div>

                                            <div matLine class="note-details">
                                                <span>{{ item.admissionDate | date: 'dd/MM/yyyy' }} to
                                                    {{item.dischargeDate | date: 'dd/MM/yyyy'}}</span>
                                            </div>

                                            <div matLine class="note-details preserve-line-breaks"
                                                [innerHtml]="item.dischargeSummary | formatMessage">
                                            </div>

                                            <div matLine class="note-footer">
                                                <div>Created at {{item.createdAt | date:
                                                    'HH:mm'}}</div>
                                            </div>

                                            <div class="list-actions icons">
                                                <button mat-icon-button matTooltip="Restore this item"
                                                    [disabled]="restoringIds.has(item.id)"
                                                    (click)="restoreItem(item)">
                                                    <mat-icon *ngIf="!restoringIds.has(item.id)">restore</mat-icon>
                                                    <mat-spinner *ngIf="restoringIds.has(item.id)" diameter="20" class="button-spinner"></mat-spinner>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </mat-list-item>
                            </ng-container>
                        </ng-container>
                    </mat-list>
                </ng-container>
            </ng-container>
        </ng-template>

        <ng-template #noResults>
            <p class="no-records-message">No deleted timeline items found.</p>
        </ng-template>
    </div>

    <div mat-dialog-actions>
        <button mat-button (click)="close()">Close</button>
    </div>
</div>

